import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { Link } from 'react-router-dom';
import { BaseActionsProps } from '../../../types/base';
import styles from './baseActions.module.sass';
import { useTranslation } from 'react-i18next';

const BaseActions: React.FC<BaseActionsProps> = ({
  base,
  isAdmin,
  isAddedToCart,
  isEditing,
  onEditToggle,
  onSave,
  onCancel,
  onAddToCart,
  onDeleteFromCart,
  onDelete,
}) => {
  const { t } = useTranslation();

  if (isAdmin) {
    return isEditing ? (
      <ButtonGroup
        className={styles.buttonGroup}
        variant="contained"
        size="small"
      >
        <Button color="success" onClick={onSave}>
          <span className="material-icons">save</span>
        </Button>
        <Button className={styles.actionButton} onClick={onCancel}>
          <span className="material-icons">cancel</span>
        </Button>
        <Button
          className={`${styles.actionButton} ${styles.deleteButton}`}
          color="error"
          onClick={() => onDelete?.(base.id, base.title)}
        >
          <span className="material-icons">delete</span>
        </Button>
      </ButtonGroup>
    ) : (
      <ButtonGroup
        className={styles.buttonGroup}
        variant="contained"
        size="small"
      >
        <Button
          className={styles.adminEditButton}
          color="primary"
          onClick={onEditToggle}
        >
          <span className="material-icons">edit</span>
        </Button>
      </ButtonGroup>
    );
  }

  return isAddedToCart ? (
    <ButtonGroup
      variant="contained"
      size="small"
      className={styles.buttonGroup}
    >
      <Button component={Link} to="/cart" color="success">
        <span className="material-icons">shopping_cart</span>
        {t('usersBases.navigate')}
      </Button>
      <Button color="error" onClick={() => onDeleteFromCart?.(base.id)}>
        <span className="material-icons">remove_shopping_cart</span>
      </Button>
    </ButtonGroup>
  ) : (
    <ButtonGroup
      className={styles.buttonGroup}
      variant="contained"
      size="small"
    >
      <Button
        variant="contained"
        color="primary"
        onClick={() => onAddToCart?.(base.id)}
      >
        <span className="material-icons">add_shopping_cart</span>
      </Button>
    </ButtonGroup>
  );
};

export default BaseActions;
